export const dateObjToString = (date?: Date) => (date ? date.toISOString().substring(0, 10) : "")

export function getFirstUnixMsOnDay(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() - 1
}
